"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledGroup = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.StyledGroup = (0, styled_components_1.default)(wl_ui_kit_1.ButtonGroup) ``;
exports.StyledButton = (0, styled_components_1.default)(wl_ui_kit_1.Button) `
  height: ${(0, wl_ui_kit_1.getSizeBy)(9)};
  color: ${({ $isSelected }) => ($isSelected ? (0, wl_ui_kit_1.getColor)('onPrimary') : 'initial')};

  &,
  &:focus,
  &:active > span:first-child {
    background-color: ${({ $isSelected }) => ($isSelected ? (0, wl_ui_kit_1.getColor)('primary') : 'initial')};
  }

  &:not(:disabled) svg path {
    fill: ${({ $isSelected }) => ($isSelected ? (0, wl_ui_kit_1.getColor)('onPrimary') : 'initial')};
  }
`;
//# sourceMappingURL=styled.js.map